








import { Component, Vue, Emit } from 'vue-property-decorator';
import { ALL_PAYMENT_METHODS } from '@/queries/PaymentMethod';
import PaymentMethodForm from '@/components/PaymentMethod/PaymentMethodForm.vue';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { CURRENT_UNIT } from '@/queries/Application';
import { GQL_currentUnit } from '@/queries/__generated__/currentUnit';
import { SmartQuery } from 'vue-apollo-decorator';
import { GQL_PaymentMethodCreate } from '@/queries/global';
import { GQL_createPaymentMethod } from '@/queries/__generated__/createPaymentMethod';
import { GQL_currentUnitPaymentMethods } from '@/queries/__generated__/currentUnitPaymentMethods';
import gql from 'graphql-tag';

const CREATE_PAYMENT_METHOD = gql`
  mutation createPaymentMethod($paymentMethod: PaymentMethodCreate!) {
    createPaymentMethod(input: { paymentMethod: $paymentMethod }) {
      paymentMethod {
        id
        name
      }
    }
  },
`;

@Component({
  components: {
    PaymentMethodForm,
  },
})
export default class PaymentMethodNew extends Vue {
  @SmartQuery<PaymentMethodNew, GQL_currentUnit>({
    query: CURRENT_UNIT,
    result({ data }) {
      this.data.unitId = data.currentUnit.id;
    },
  }) private currentUnit!: GQL_currentUnit;

  private CREATE_PAYMENT_METHOD = CREATE_PAYMENT_METHOD;

  private data: GQL_PaymentMethodCreate = {
    name: '',
    unitId: '',
  };

  @Emit('payment-method-created')
  private addToCache(store: InMemoryCache, query: {data: GQL_createPaymentMethod }) {
    const data = (store.readQuery({ query: ALL_PAYMENT_METHODS }) as GQL_currentUnitPaymentMethods);
    if (!data.currentUnit || !query.data.createPaymentMethod?.paymentMethod) return;
    const paymentMethod = query.data.createPaymentMethod!.paymentMethod!;
    data.currentUnit.paymentMethods.push(paymentMethod);
    store.writeQuery({ query: ALL_PAYMENT_METHODS, data });

    return paymentMethod;
  }
}
